export const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export const entranceEase = 'cubic-bezier(.16,1,.3,1)';

/** Cancel back to the visible CSS default when the preference changes mid-flight. */
export function animateElements(elements, frames, options) {
  if (reducedMotion()) return () => {};
  const animations = elements.map((element, index) => element.animate(frames,
    typeof options === 'function' ? options(index) : options));
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cancel = () => animations.forEach(animation => animation.cancel());
  const change = () => { if (media.matches) cancel(); };
  media.addEventListener('change', change);
  return () => { cancel(); media.removeEventListener('change', change); };
}
